export const transformStrToUnderscore = (str = '') => str.toLowerCase().split(' ').join('_')

export const transformToUnderscore = (str = '') => str.toLowerCase().replace(/[/ ]/g, '_')

export const transformStrToCapital = (str = '', separators = ['-', '_']) =>
  separators
    .reduce((newStr, separator) => newStr.split(separator).join(' '), str)
    .replace(/\s+/g, ' ')
    .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
    .trim()
